import { findPanelExtra, picoFormulas, alumBifoldPanelWidth } from "./calculatePanelWidth";

type Args = {
  stiles: string;
  numberOfPanels: number;
  material: string;
  width: number;
  isPrimary: boolean;
  exactConfig: string;
};

export default function calculateCornerPanelWidth(cornerArgs: Args) {
  const { stiles, numberOfPanels, material, width, isPrimary, exactConfig } =
    cornerArgs;

  if(material === "All Aluminum"){
    return alumBifoldPanelWidth(width, numberOfPanels, exactConfig)
  }

  const extra = findPanelExtra(numberOfPanels);

  const sub = material === "All Wood" ? 0.0625 : 0;
  const cornerJamb = 0.9375;
  let allPanels = 0;

  if (isPrimary) {
    allPanels =
      width - (cornerJamb - sub) - ((numberOfPanels + 1) * 0.125 + extra);
  } else {
    allPanels =
      width - (cornerJamb - sub) - ((numberOfPanels - 1) * 0.125 + 0.1875);
  }

  if (stiles?.includes("Pico")) {
    return picoFormulas(allPanels - 0.125, numberOfPanels, exactConfig);
  }

  return allPanels / numberOfPanels - 0.015;
}
